import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-input-2'

import { isValidPhoneNumber } from "react-phone-number-input";

// img
import hide from "../assets/images/hide.svg";
import login from "../assets/images/login.svg";
import lock from "../assets/images/lock.svg";
import email from "../assets/images/email.svg";
import eye from "../assets/images/eye.svg";
import user from "../assets/images/user.svg";
import mobile from "../assets/images/mobile.svg";
import register_logo from "../assets/images/logo_dark.png";
import { ValidateUserName, validSpecialPositive, ValidateEmail } from "../helper/validation";
import { registerUser, isValidCampign } from "../action/user.action";
import { toastAlert } from "../utils/toast";
import { validPositive } from "../helper/validation";
import { useTranslation, Trans } from "react-i18next";
// import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { getSiteSetting } from "../action/user.action";

import Footer from "../components/Footer.js";
import isEmpty from "../lib/isEmpty.js";
import "react-phone-input-2/lib/style.css";

let initialstate = {
  fullName: "",
  lastname: "",
  emailId: "",
  phone: "",
  phoneNo: "",
  phoneCode: "",
  password: "",
  confirmpassword: ""
};

export default function Register() {
  // const { CampaignId } = useParams();
  const [settting, setSiteSettings] = useState({})
  const { t } = useTranslation()
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [reshowPassword, setreShowPassword] = useState(false);

  const [formdata, setformdata] = useState(initialstate);
  const [validateError, setValidateError] = useState({});
  const [passmessage, setpassmessage] = useState("");

  const [message, setMessage] = useState("");
  const [progress, setProgress] = useState("");
  const [disable, setDisable] = useState(false)
  // const [isValidC, setIsValidC] = useState(false);

  const { fullName, lastname, emailId, phone, phoneCode, phoneNo, password, confirmpassword } = formdata;

  // useEffect(() => {
  //   checkValidCapmCode();
  // }, [CampaignId]);

  // const checkValidCapmCode = async () => {
  //   if (CampaignId) {
  //     console.log("Hi");
  //     const payload = {
  //       refCode: CampaignId
  //     };
  //     const check = await isValidCampign(payload);
  //     console.log(check,'check');
  //     if (check.result) {
  //       setIsValidC(true);
  //     }
  //   }
  // };

  const handleChange = (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      let formData = { ...formdata, ...{ [name]: value } };
      setformdata(formData);
      if (name == "password") {
        handlePassword1(value);
      }
    } catch (err) { }
  };
 const handlePhoneNumber = (value, country) => {
    const { dialCode } = country;
    let phoneNo = value;
    let formData = formdata;

    if (!isValidPhoneNumber('+' + value) && value.length > 3) {
      setValidateError({ ...validateError, ...{ 'phoneNo': t('MOBILE_NUMBER_INVALID') } });
    } else {
      setValidateError({ ...validateError, ...{ 'phoneNo': '' } });
    }
    if (isEmpty(value)) {
      setValidateError({ ...validateError, ...{ 'phoneNo': '' } });
    }
    if (dialCode) {
      formData = {
        ...formdata, ...{
          phoneCode: dialCode,
          phoneNo: phoneNo.slice(dialCode.length),
        }
      }
    } else if (value) {
      formData = { ...formdata, ...{ phoneNo } }
    }

    setformdata(formData);
  }
  const Fromvalidation = async () => {
    try {
      var validateError = {};
      if (fullName.trim() == "") {
        validateError.name = "FIRST_NAME_REQUIRED";
      } else if (!ValidateUserName(fullName)) {
        validateError.name = "ALPHABETS_CHECK";
      }

      // if (lastname.trim() == "") {
      //   validateError.lastname = "LAST_NAME_REQUIRED";
      // } else if (!ValidateUserName(lastname)) {
      //   validateError.lastname = "ALPHABETS_CHECK";
      // }


      if (emailId.trim() == "") {
        validateError.email = "EMAIL_REQUIRED";
      } else if (!ValidateEmail(emailId)) {
        validateError.email = "EMAIL_INVALID";
      }
      if (phoneNo.trim() == "") {
        validateError.phoneNo = "MOBILE_NUMBER_REQUIRED";
      }

      if (password.trim() == "") {
        validateError.password = "PASSWORD_REQUIRED";
      } else if (Object.keys(passmessage).length != 0) {
        validateError.password = passmessage;
      }
      if (confirmpassword.trim() == "") {
        validateError.confirmpassword = "CONFIRM_PASSWORD_REQUIRED";
      } else if (password != confirmpassword) {
        validateError.confirmpassword =
          "CONFIRM_PASSWORD_MISMATCH";
      }

      setValidateError(validateError);
      return validateError;
    } catch (err) {
      //console.log(err);
    }
  };

  const handleSubmit = async () => {
    try {      
      if (!isEmpty(phoneCode) || !isEmpty(phoneCode)) {
        if (!isValidPhoneNumber('+' + phoneCode + phoneNo)) {
          setValidateError({ ...validateError, ...{ 'phoneNo': t('MOBILE_NUMBER_INVALID') } });
          return
        }
      }
      const check = await Fromvalidation();
      var errorsSize = Object.keys(check).length;
      if (errorsSize == 0) {
        var reqbody = {
          email: emailId,
          password: password,
          phoneCode: phoneCode,
          phoneNo: phoneNo,
          confirmPassword: confirmpassword,
          fullName: fullName,
          lastname: lastname
          // CampaignId:CampaignId
        };
        setDisable(true)
        const data = await registerUser(reqbody);

        if (data.status == false) {
          setDisable(false)
          // setloading(false);
          var validateError = {};
          validateError.email = data.error.email;
          validateError.password = data.error.password;
          validateError.phoneNo = data.error.phoneNo;
          setValidateError(validateError);
        } else {
          toastAlert("success", t("REGISTER_SUCCESS"));
          sessionStorage.setItem("USER_AUTH_VERIFY_TOKEN_DATA", data.result);
          setDisable(false)
          // setTimeout(() => {
          //   navigate("/login");
          // }, [1500]);
          setTimeout(() => {
            window.location.href = "/thank-you";
          }, [1500]);
        }
      }
    } catch (err) {
      console.log(err);
      setDisable(false)
    }
  };

  const handlePassword1 = (passwordValue) => {
    const strengthChecks = {
      length: 0,
      length1: 0,
      hasUpperCase: false,
      hasLowerCase: false,
      hasDigit: false,
      hasSpecialChar: false
    };

    strengthChecks.length = passwordValue.length >= 8 ? true : false;
    strengthChecks.length1 = passwordValue.length < 18 ? true : false;
    strengthChecks.hasUpperCase = /[A-Z]+/.test(passwordValue);
    strengthChecks.hasLowerCase = /[a-z]+/.test(passwordValue);
    strengthChecks.hasDigit = /[0-9]+/.test(passwordValue);
    strengthChecks.hasSpecialChar = /[^A-Za-z0-9]+/.test(passwordValue);
    var errormsg = {};
    if (!strengthChecks.length) {
      errormsg = "PASSWORD_MIN";
    } else if (!strengthChecks.length1) {
      errormsg = "PASSWORD_MAX";
    } else if (!strengthChecks.hasUpperCase) {
      errormsg = "PASSWORD_UPPER";
    } else if (!strengthChecks.hasLowerCase) {
      errormsg = "PASSWORD_LOWER";
    } else if (!strengthChecks.hasDigit) {
      errormsg = "PASSWORD_NUMERIC";
    } else if (!strengthChecks.hasSpecialChar) {
      errormsg = "PASSWORD_SPECIAL";
    }
    setpassmessage(errormsg);
    let verifiedList = Object.values(strengthChecks).filter((value) => value);
    let strength =
      verifiedList.length == 6
        ? t("STRONG")
        : verifiedList.length >= 2 && strengthChecks.length1 == true
          ? t("MEDIUM")
          : t("WEAK");

    setProgress(`${(verifiedList.length / 6) * 100}%`);
    setMessage(strength);
  };

  const getActiveColor = (type) => {
    if (type === "Strong") return "#8BC926";
    if (type === "Medium") return "#FEBD01";
    return "red";
  };

 
  const handlePassword = () => {
    setShowPassword(!showPassword);
  };

  const rePassword = () => {
    setreShowPassword(!reshowPassword);
  };

  const containedChange = (event) => {
    if (event.key.length === 1 && event.code.startsWith('Key') && event.code.length === 4 && event.target.value.indexOf(event.key) !== -1) {
      event.preventDefault()
      return false;
    }

    return true
  }

  const getSiteSettings = async () => {
    try {

      const { status, result } = await getSiteSetting()
      if (status) {
        setSiteSettings(result)
      }

    } catch (error) {
      console.log(error)
    }
  }

  const appearance = {
    theme: "stripe",
  };
  const options = {
    appearance,
  };
  useEffect(() => {
    getSiteSettings()
  }, [])

  return (
    <>
      <div className="login">
        <div className="left">
          <div className="w-75">
            <a href="/" className="xs_display mb-3" style={{ display: "none" }}>
              <img src={register_logo} className="img-fluid mb-4" alt="img" width={200} />
            </a>
            <h2>
              <Trans i18nKey="REGISTER_HEADER" components={{ span: <span /> }} values={{ DSGIANTS: 'DSGIANTS' }} />

              {/* Register with <span> DSGIANTS</span> */}
            </h2>

            <div className="input_box mb-4">
              <label className="mb-3">{t("FULL_NAME")}</label>
              <div class="input-group">
                <span class="input-group-text">
                  <img src={user} className="img-fluid" alt="img" />
                </span>
                <input
                  type="text"
                  class="form-control py-3"
                  placeholder={t("FULL_NAME_PLACEHOLDER")}
                  value={fullName}
                  name="fullName"
                  onChange={handleChange}

                />
              </div>{" "}
              {validateError.name && (
                <span className="text-danger">{t(validateError.name)}</span>
              )}
            </div>
            {/* <div className="input_box mb-4">
              <label className="mb-3">{t("LAST_NAME")}</label>
              <div class="input-group">
                <span class="input-group-text">
                  <img src={user} className="img-fluid" alt="img" />
                </span>
                <input
                  type="text"
                  class="form-control py-3"
                  placeholder={t("LAST_NAME_PLACEHOLDER")}
                  name="lastname"
                  onChange={handleChange}

                />
              </div>{" "}
              {validateError.lastname && (
                <span className="text-danger">{t(validateError.lastname)}</span>
              )}
            </div> */}
            <div className="input_box mb-4">
              <label className="mb-3">{t("EMAIL")}</label>
              <div class="input-group">
                <span class="input-group-text">
                  <img src={email} className="img-fluid" alt="img" />
                </span>
                <input
                  type="text"
                  class="form-control py-3"
                  placeholder={t("EMAIL_PLACEHOLDER")}
                  name="emailId"
                  onChange={handleChange}
                />
              </div>
              {validateError.email && (
                <span className="text-danger">{t(validateError.email)}</span>
              )}
            </div>

            <div className="input_box mb-4">
              <label className="mb-3">{t("MOBILE_NUMBER")}</label>
              {/* <div class="input-group">
                <span class="input-group-text">
                  <img src={mobile} className="img-fluid" alt="img" />
                </span>
                <input
                  // type={phone ? "number" : 'text'}
                  class="form-control py-3"
                  placeholder={t("MOBILE_PLACEHOLDER")}
                  name="phone"
                  onChange={handleChange}
                  onInput={validPositive}

                />

              </div> */}
              <PhoneInput
                placeholder={t("MOBILE_PLACEHOLDER")}
                value={phoneCode + phoneNo}
                onChange={handlePhoneNumber}
                specialLabel={false}
                enableSearch={true}
                country={'us'}
              />

              {validateError.phoneNo && (
                <span className="text-danger">{t(validateError.phoneNo)}</span>
              )}
            </div>

            <div className="input_box mb-4">
              <label className="mb-3">{t("PASSWORD")}</label>
              <div class="input-group">
                <span class="input-group-text">
                  <img src={lock} className="img-fluid" alt="img" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  class="form-control py-3"
                  name="password"
                  placeholder={t("PASSWORD_PLACEHOLDER")}
                  onChange={handleChange}
                />
                <span
                  class="input-group-text cursor-pointer"
                  onClick={handlePassword}
                >
                  <img
                    src={showPassword ? eye : hide}
                    className="img-fluid"
                    alt="img"
                  />
                </span>
              </div>
              {validateError.password && (
                <span className="text-danger">{t(validateError.password)}</span>
              )}
            </div>
            {password.length !== 0 ? (
              <>
                <div className="progress-bg">
                  <div
                    className="progress"
                    style={{
                      marginTop: "-24px",
                      height: "6px",
                      width: progress,
                      backgroundColor: getActiveColor(t(message))
                    }}
                  ></div>
                </div>
                <p className="message" style={{ color: getActiveColor(t(message)) }}>
                  {t("YOUR_PASSWORD")} {t(message)}
                </p>
              </>
            ) : null}

            <div className="input_box mb-4">
              <label className="mb-3">{t("CONFIRM_PASSWORD")}</label>
              <div class="input-group">
                <span class="input-group-text">
                  <img src={lock} className="img-fluid" alt="img" />
                </span>
                <input
                  type={reshowPassword ? "text" : "password"}
                  class="form-control py-3"
                  name="confirmpassword"
                  placeholder={t("CONFIRM_PASSWORD_PLACEHOLDER")}
                  onChange={handleChange}
                />
                <span
                  class="input-group-text cursor-pointer"
                  onClick={rePassword}
                >
                  <img
                    src={reshowPassword ? eye : hide}
                    className="img-fluid"
                    alt="img"
                  />
                </span>
              </div>{" "}
              {validateError.confirmpassword && (
                <span className="text-danger">
                  {t(validateError.confirmpassword)}
                </span>
              )}
            </div>

            <div class="form-check mb-4">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              />
              <label class="form-check-label" for="flexCheckChecked">
                I accept and agree to the <Link to="/terms" target="_blank" className="text-decoration-none">Terms of Service</Link> & <Link to="/about" target="_blank" className="text-decoration-none">About Us</Link>
              </label>
            </div>

            <button
              className="primary_btn mb-4 w-100"
              onClick={handleSubmit}
              disabled={disable}
            >
              {/* {isValidC ? "Register" : "Camp ID Not Valid"} */}
              {t("REGISTER")}
            </button>
            <div className="signup text-center">
              {t("ALREADY_HAVE_ACCOUNT")}? <a href="/login">{t("LOGIN_HERE")}</a>
            </div>
          </div>
          <ul class="cta_list cta_list_register">
            <li>
              <div className="round">
                <div>
                  <a

                    href={settting?.whatsappLink}
                    className="whatsapp_btn"
                    target="_blank"
                    style={{ textDecoration: "none", padding: "12px" }}
                  >
                    <svg
                      style={{
                        width: "24px",
                        height: "24px",
                      }}
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {" "}
                      <path
                        d="M0.034668 32L2.27334 24.049C0.833743 21.6033 0.0757846 18.8207 0.0757846 15.9621C0.0757846 7.16059 7.23637 0 16.0379 0C24.8395 0 32 7.16059 32 15.9621C32 24.7637 24.8395 31.9243 16.0379 31.9243C13.2954 31.9243 10.61 31.2223 8.23431 29.8893L0.034668 32ZM8.6535 26.9853L9.1421 27.2837C11.2134 28.5482 13.598 29.2166 16.0379 29.2166C23.3464 29.2166 29.2923 23.2706 29.2923 15.9621C29.2923 8.65364 23.3464 2.70771 16.0379 2.70771C8.72942 2.70771 2.78349 8.65364 2.78349 15.9621C2.78349 18.5087 3.50725 20.9816 4.87635 23.1136L5.20539 23.626L3.91622 28.2048L8.6535 26.9853Z"
                        fill="white"
                      ></path>{" "}
                      <path
                        d="M11.554 8.53295L10.5182 8.47649C10.1929 8.45874 9.87378 8.56744 9.62788 8.78105C9.12575 9.21709 8.32286 10.0601 8.07626 11.1586C7.70852 12.7966 8.27683 14.8023 9.74772 16.808C11.2186 18.8137 13.9597 22.0229 18.8068 23.3935C20.3688 23.8351 21.5975 23.5374 22.5455 22.9309C23.2963 22.4507 23.8139 21.6798 24.0004 20.8083L24.1658 20.0359C24.2183 19.7904 24.0937 19.5413 23.8656 19.4362L20.3651 17.8227C20.1379 17.718 19.8684 17.7842 19.7156 17.9822L18.3414 19.7637C18.2376 19.8983 18.0599 19.9517 17.8994 19.8953C16.9583 19.5646 13.806 18.2443 12.0763 14.9124C12.0012 14.7679 12.0199 14.5925 12.1263 14.4692L13.4396 12.9499C13.5738 12.7948 13.6077 12.5767 13.5271 12.3881L12.0182 8.85797C11.9379 8.67004 11.7578 8.54408 11.554 8.53295Z"
                        fill="white"
                      ></path>{" "}
                    </svg>
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="right d-none d-lg-flex">
          <div className="text-center">
            <a href="/">
              <img src={register_logo} className="img-fluid mb-4" alt="img" width={200} />
            </a>
            <p className="para mb-5">
              {t("REGLOGIN_CONTENT")}
            </p>
            <img src={login} className="img-fluid" alt="img" />
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
}
